module.exports = __webpack_public_path__ + "static/media/2BWDCE1.crop.a7176721.jpg";